
export type InviteUsersBody = {
  userIds: string[];
};
